/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchaseunavailablestoreoutdated5Inputs */



/**
* | output |
* | --- |
* | "Please update the RuStore app and try again." |
*
* @param {Subscriptionalertpurchaseunavailablestoreoutdated5Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchaseunavailablestoreoutdated5 = /** @type {((inputs?: Subscriptionalertpurchaseunavailablestoreoutdated5Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchaseunavailablestoreoutdated5Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Please update the RuStore app and try again.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualiza la app RuStore e inténtalo de nuevo.")
	return /** @type {LocalizedString} */ ("Обновите приложение RuStore и попробуйте ещё раз.")
});
export { subscriptionalertpurchaseunavailablestoreoutdated5 as "subscriptionAlertPurchaseUnavailableStoreOutdated" }